module.exports = __webpack_public_path__ + "img/TSCO.e7e1a245.png";